import { GoogleTagManagerTracker } from "./google-tag-manager-tracker";

export default GoogleTagManagerTracker;
